import React from "react";

const History = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2c3.9 0 7.3 2.2 8.9 5.5" />
      <path d="M21.8 1.7L21 7.6l-6-.8M12 7v5H7" />
    </g>
  </svg>
);

export default History;



// WEBPACK FOOTER //
// ./src/theme/icons/History.js